import { createStore } from "vuex";
import contracts from "./modules/contracts";
import tagsValues from "./modules/tagsValues";
import minting from "./modules/minting";
import registration from "./modules/registration";
import auth from "./modules/auth";
// import cardanoFunctions from "./modules/cardanoFunctions";
import nfts from "./modules/nfts";
import users from "./modules/users";
import userProfile from "./modules/userProfile";
import nftDetails from "@/store/modules/nftDetails";
import VuexPersistence from "vuex-persist";

const vuexLocal = new VuexPersistence({
  reducer: (state) => ({
    contracts: state.contracts,
  }),
  storage: window.localStorage,
});

export default createStore({
  modules: {
    contracts,
    // cardanoFunctions,
    tagsValues,
    minting,
    registration,
    auth,
    nfts,
    users,
    userProfile,
    nftDetails,
  },
  plugins: [vuexLocal.plugin],
});
